import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { FileSubjectTypes } from "@/types/fileTypes";
import { ParameterSubjectType } from "@/types/parameterTypes";
import { Operation } from "@/backend/models/operation";
import { I18n } from "@/i18n/I18n";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";
import { FileUploader } from "../files/FileUploader";
import { ParameterLink } from "../parameters/ParameterLink";
import { TextInput } from "./TextInput";


export function OperationFileUploader(props: { operation: Operation }) {
  const { operation } = props;
  const field = useParameterStore((state) => state.findFieldForOperation(operation.id));
  const fetchParameter = useParameterStore(state => state.fetchParameter);
  const [parameter] = useParameterStore(useShallow((state) => state.parametersForSubject(operation.id, ParameterSubjectType.OPERATION)));

  if (!field) return null;

  return (
    <div className='w-100'>
      <TextInput operation={operation} />
      <CollectedFileNameInput operation={operation} />
      <div className='pt-2'>
        <FileUploader
          subjectId={field.id}
          subjectType={FileSubjectTypes.CUSTOM_FIELD}
          file={field.file}
          inputConstraint={operation.inputConstraint}
          refetchSubject={() => void fetchParameter(field.subjectId)}
        />
      </div>
      <table>
        <tbody>
          <ParameterLink parameter={parameter} operation={operation} />
        </tbody>
      </table>
  </div>
  );
}

// Lets the procedure author name the file this operation collects, so a collected CSV is
// identified by the condition it was captured under rather than by whatever the provider
// happened to write to disk.
export function CollectedFileNameInput(props: { operation: Operation }) {
  const { operation } = props;
  const updateOperation = useTreeStore(state => state.updateOperation);
  const [collectedFileName, setCollectedFileName] = useState(operation.collectedFileName);
  const inputId = `collectedFileName-${operation.id}`;

  useEffect(() => {
    setCollectedFileName(operation.collectedFileName);
  }, [operation.collectedFileName]);

  return (
    <div className='pt-2'>
      <Form.Label className="col-form-label col-form-label-sm" htmlFor={inputId}>{I18n.get('collectedFileName')}</Form.Label>
      <Form.Control
        size="sm"
        type="text"
        id={inputId}
        name="collectedFileName"
        value={collectedFileName}
        placeholder={I18n.get('collectedFileNamePlaceholder')}
        onChange={(event) => setCollectedFileName(event.target.value)}
        onBlur={() => void updateOperation({ operation: { ...operation, collectedFileName } })}
      />
      <Form.Text muted>{I18n.get('collectedFileNameHelp')}</Form.Text>
    </div>
  );
}
